import { Card, CardBody, Col } from 'reactstrap'
import { SolidBorderStyles } from '../../../../../Utils/Constants'
import CommonCardFooter from '../Common/CommonCardFooter'
import { solidBorderStyleData } from '../../../../../Data/Forms/FormsControl/MegaOption/MegaOption'
import SolidBorderStyleForm from './SolidBorderStyleForm'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const SolidBorderStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CardHeaderCommon title={SolidBorderStyles} span={solidBorderStyleData} />
        <CardBody className='megaoptions-border-space-sm'>
          <SolidBorderStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light"/>
      </Card>
    </Col>
  )
}

export default SolidBorderStyle